<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-code-square`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 6a2 2 0 00-2-2H8a2 2 0 00-2 2v36a2 2 0 002 2h32a2 2 0 002-2V6zM10 8h28v32H10V8zm20.268 9l3.864 1.035L29.99 33.49l-3.864-1.035L30.268 17zm-5.954 2.121l-2.829-2.828L13 24.778l.318.318-.025.025L21.07 32.9l2.83-2.83-5.268-5.268 5.683-5.682z"/></svg>
</template>
<script>

export default {
  name: 'IconCodeSquare',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
